import * as React from 'react';
export const producthuntSvg = React.forwardRef(function producthuntSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M28 16c0 6.627-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4s12 5.373 12 12Z',
      fill: '#DA552F',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.6 16h-3.4v-3.6h3.4a1.8 1.8 0 1 1 0 3.6Zm0-6h-5.8v12h2.4v-3.6h3.4a4.2 4.2 0 0 0 0-8.4Z',
      fill: '#fff',
    }),
  );
});
producthuntSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var producthunt = {
  category: 'brand',
  colorable: false,
  name: 'producthunt',
  svg: producthuntSvg,
};
